import { useEffect } from 'react';

import { HeaderSection } from '@/common/constants/HeaderSection';
import { useAppStore } from '@/common/stores/AppStore';

export function useHeaderSection(headerSection: Nullable<HeaderSection>) {
  const { setHeaderSection } = useAppStore();

  useEffect(() => {
    if (headerSection !== HeaderSection.Dynamic) {
      setHeaderSection(headerSection);
    }
  }, [headerSection, setHeaderSection]);
}
